<template>
	<div>
		<el-select
			v-model="id"
			filterable
			default-first-option
			size="mini"
			remote
			:allow-create="params.allowCreate"
			:clearable="true"
			:placeholder="params.placeholder || '请输入搜索'"
			@change="handleChange"
			:remote-method="refreshData"
			:loading="loadings.main"
		>
			<el-option v-for="item in options" :key="item._id" :label="calcName(item)" :value="item._id"></el-option>
		</el-select>
	</div>
</template>
<script>
import RelateInput from "@/mixins/RelateInput.js";
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM, RelateInput],
	props: {
		dataModelName: {
			type: String,
			default: "User"
		}
	},

	watch: {
		dataModelName: {
			handler(val) {
				this.dataModel = this.dataModelName;
			},
			immediate: true
		}
	}
};
// export default {
// 	data() {
// 		return {
// 			id: "",
// 			loading: false,
// 			options: [],
// 			myValue: {
// 				name: "",
// 				_id: ""
// 			}
// 		};
// 	},
// 	props: {
// 		dataModelName: {
// 			type: String,
// 			default: "user"
// 		},
// 		nameFields: {
// 			type: Array,
// 			default: () => {
// 				return ["name"];
// 			}
// 		},
// 		value: {
// 			type: Object,
// 			default: () => {
// 				return {
// 					_id: "",
// 					name: ""
// 				};
// 			}
// 		}
// 	},
// 	computed: {},
// 	created() {},
// 	mounted() {
// 		if (typeof this.value === "string") {
// 			this.value = {
// 				_id: this.value,
// 				name: ""
// 			};
// 		}
// 		this.resetEditor(this.value);
// 		this.refreshData(this.value.name);
// 	},
// 	methods: {
// 		resetEditor(val) {
// 			this.myValue = {};
// 			this.id = val._id;
// 			for (let k in val) {
// 				this.$set(this.myValue, k, val[k]);
// 			}
// 		},
// 		calcName(item) {
// 			if (this.nameFields.length > 0) {
// 				let names = [];
// 				for (let k in this.nameFields) {
// 					names.push(item[this.nameFields[k]]);
// 				}
// 				return names.join(" / ");
// 			} else {
// 				return item[this.nameFields[0]];
// 			}
// 		},
// 		refreshData(query) {
// 			this.loading = true;
// 			debugger;
// 			this.$axios
// 				.post("/curd/search/" + this.dataModelName, {
// 					query: query,

// 				})
// 				.then(json => {
// 					this.loading = false;
// 					this.options = [];
// 					for (let i = 0; i < json.data.datas.length; i++) {
// 						this.options.push(json.data.datas[i]);
// 					}
// 				})
// 				.catch(json => {
// 					this.loading = false;
// 					this.$message.error(json.data.msg);
// 				});
// 			return [];
// 		},
// 		handleChange(val) {
// 			console.log("CHANGED", typeof val);
// 			console.log("myValue", this.myValue);

// 			if (typeof val == "object") {
// 				this.$emit("input", this.myValue);
// 				this.$emit("change", this.myValue);
// 				return;
// 			}
// 			if (val === "") {
// 				//清空
// 				this.myValue = {
// 					_id: "",
// 					name: ""
// 				};
// 				this.$emit("input", this.myValue);
// 				this.$emit("change", this.myValue);
// 				return;
// 			}
// 			//新建

// 			this.myValue = {
// 				name: val,
// 				_id: ""
// 			};
// 			this.$confirm("确认创建" + this.myValue.name + "?", "提示", {
// 				confirmButtonText: "确定",
// 				cancelButtonText: "取消",
// 				type: "warning"
// 			})
// 				.then(() => {
// 					this.loading = true;
// 					this.$axios
// 						.post("/curd/do_quick_create/" + this.dataModelName, {
// 							name: this.myValue.name
// 						})
// 						.then(json => {
// 							this.loading = false;
// 							this.$message({
// 								type: "success",
// 								message: "创建成功!"
// 							});
// 							this.options.push(json.data.info);
// 							this.$nextTick(() => {
// 								for (let k in json.data.info) {
// 									this.$set(this.myValue, k, json.data.info[k]);
// 								}
// 								this.$emit("input", this.myValue);
// 								this.$emit("change", this.myValue);
// 							});
// 						})
// 						.catch(json => {
// 							this.loading = false;
// 							this.$message.error(json.data.msg);
// 						});
// 				})
// 				.catch(() => {
// 					this.myValue = {
// 						_id: "",
// 						name: ""
// 					};
// 					this.$message({
// 						type: "info",
// 						message: "已取消"
// 					});
// 				});
// 		}
// 	},
// 	watch: {
// 		value: function(val) {
// 			this.resetEditor(val);
// 		}
// 	},
// 	components: {}
// };
</script>
<style lang="scss" scoped>
</style>
